import { createContext } from "react";

const ReportsContext = createContext({
  codClients: [],
  reportClients: [],
  reportsStatus: "idle",
});

export { ReportsContext };